import { type Maybe } from '@pi/types';
import _ from 'lodash';

export const intersectQueries = (
    a?: Maybe<Record<string, any>>,
    b?: Maybe<Record<string, any>>,
): Record<string, any> => {
    if (_.isEmpty(a)) return b ?? {};
    if (_.isEmpty(b)) return a ?? {};

    return {
        $and: [a, b],
    };
};
